<div class="l-title">
  <h2 class="c-title">{{ label }}</h2>
</div>
